import { create } from 'zustand';

type Store = {
  isVisible: boolean;
  showTooltip: (wait?: number) => void;
  reset: () => void;
};
const useAddCartTooltipStore = create<Store>((set) => ({
  isVisible: false,
  showTooltip: (wait = 3000) => {
    set(() => ({ isVisible: true }));

    setTimeout(() => set(() => ({ isVisible: false })), wait);
  },
  reset: () => set(() => ({ isVisible: false })),
}));

export default useAddCartTooltipStore;
